import { ApolloProvider } from '@apollo/client';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {
  ACCUEIL_URL,
  ARCHIVE_URL,
  COMMISSIONING_URL,
  CONVERSION_URL,
  CREATION_URL,
  FAQ_URL,
  HISTORY_URL,
  LOGIN_URL,
  SIGN_UP_URL,
  SIGNUP_URL_ID,
} from '../../constant/url';
import { AuthProvider } from '../../provider/Authprovider';
import { BalanceProvider } from '../../provider/Balanceprovider';
import { client } from '../../service/ApolloClient';
import { CustomBackdrop } from '../../common/BackDrop/BackDrop';
import PrivateRoute from '../PrivateRoute/PrivateRoute';

const PageAccueil = lazy(() =>
  import('../Main/acceuil/newAccueil/NewAccueil').then(m => ({
    default: m.PageAccueil,
  })),
);
const Homepage = lazy(() => import('../Main/homepage/Home'));
const SignUpPage = lazy(() => import('../Main/singup/SignUp'));
const CardSignUpID = lazy(() => import('../Main/singup/CardSignUPID/CardSignUpID'));
const Transfert = lazy(() =>
  import('../Main/transfert/Transfert').then(m => ({ default: m.Transfert })),
);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#B48A4E',
    },
  },
  overrides: {
    MuiToolbar: {
      root: {
        backgroundColor: '#B48A4E!important',
      },
    },
  },
});

const Router = () => {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <BalanceProvider>
             <BrowserRouter basename="/chain4transition">
              <Suspense fallback={<CustomBackdrop open />}>
                <Switch>
                  <Route path={LOGIN_URL} exact component={Homepage} />
                  <Route path={SIGN_UP_URL} exact component={SignUpPage} />
                  <Route path={SIGNUP_URL_ID} exact component={CardSignUpID} />
                  <PrivateRoute
                    path={[
                      ACCUEIL_URL,
                      HISTORY_URL,
                      FAQ_URL,
                      CONVERSION_URL,
                      CREATION_URL,
                      COMMISSIONING_URL,
                      ARCHIVE_URL,
                    ]}
                    exact
                    component={PageAccueil}
                  />
                  <PrivateRoute
                    path={'/accueil/transfert/:id'}
                    exact
                    component={Transfert}
                  />
                </Switch>
              </Suspense>
            </BrowserRouter>
          </BalanceProvider>
        </AuthProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default Router;
